<template>
  <div>
    <menu-header />
    <div :class="classObj" class="app-wrapper">
      <!--      <side-menu />-->
      <div class="main-container">
        <app-main />
      </div>
    </div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
// import SideMenu from './components/SideMenu.vue'
import AppMain from './components/AppMain.vue'

export default {
  name: 'Layout',
  components: {
    AppMain,
    // Sidebar,
    MenuHeader: Header
    // SideMenu
  },
  computed: {
    classObj() {
      return {
        hideSidebar: false,
        openSidebar: true,
        withoutAnimation: true,
        mobile: false
      }
    }
  },
  data() {
    return {
      // bgUrl: require('@/assets/images/bg-platform.png')
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style lang="scss" scoped>
$sideBarWidth: 160px;
.app-wrapper {
  margin-top: 50px;
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  //width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
